import { getUrlParamsFetch, urlBackend } from "@/shared";
import { erpApi } from '@/shared/axios/erp-api';
import { IConfigComisionesData, IConfigComisionesResponse, IConfigComisionesResponseParams } from "@/shared/interfaces/erp/comision/comision.interface";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi();


//CONFIGURACION DE COMISION

/**
 * OBTENER CONFIGURACION DE COMISION
 * 
*/

export const useFetchConfigComision = (params?: IConfigComisionesResponseParams) => {
  return useQuery({
    queryKey: [
      'configuracion-comiciones',
      ...Object.values(params || {})],
    queryFn: async () => {
      return await getConfigComision(params)
    },
  });
};

export const getConfigComision = async (params?: IConfigComisionesResponseParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<IConfigComisionesResponse>(
    `${urlBackend}api/v1/configuracion-comiciones/?${queryParams}`,
    true
  );
  return resp.data;
}

/**
 * CREAR UNA CONFIGURACION DE COMISION
*/

export const useFetchPostConfigComision = () => {
  const setAlert = useUiStore.getState().setAlert;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postConfigComision,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['configuracion-comiciones'] });
      setAlert(true, data.message, data.status);
    }
  });
}

export const postConfigComision = async (params?: IConfigComisionesResponseParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await post<IConfigComisionesData>(
    `${urlBackend}api/v1/configuracion-comiciones/?${queryParams}`,
    params,
    true
  );
  return resp;
}

/**
 * OBTENER CONFIGURACION COMISION POR ID
 * 
*/
export const useFetchConfigComisionById = (id: string) => {
  return useQuery({
    queryKey: [
      'configuracion-comiciones',
      id],
    queryFn: async () => {
      return await getConfigComisionById(id)
    },
  });
};

export const getConfigComisionById = async (id: string) => {
  const resp = await get<IConfigComisionesData>(
    `${urlBackend}api/v1/configuracion-comiciones/${id}/`,
    true
  );
  return resp.data;
}

/**
 * ACTUALIZAR CONFIGURACION COMISION
*/

export const useFetchPutConfigComision = () => {
  const setAlert = useUiStore.getState().setAlert;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putConfigComision,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['configuracion-comiciones'] });
      setAlert(true, data.message, data.status);
    }
  });
}

export const putConfigComision = async (params?: IConfigComisionesResponseParams) => {
  const resp = await put<IConfigComisionesData>(
    `${urlBackend}api/v1/configuracion-comiciones/${params?.id_configuracion_comiciones}/`,
    params,
    true
  );
  return resp;
}
